import { ApiListActionTypesResponse } from '../../../api/core/models';
import { BoardSettingsV2 } from '../model';

export function apiBoardSettingsToActionTypes(
  actionTypesResponse?: ApiListActionTypesResponse
): NonNullable<BoardSettingsV2['actionTypes']> {
  if (!actionTypesResponse?.ActionTypes) {
    return [];
  }
  return actionTypesResponse.ActionTypes.map((actionType) => ({
    id: actionType.id,
    displayValue: actionType.displayValue,
  }));
}
